export default {
    authDonor: state => state.authDonor,
    createNewAccountData: state => state.createNewAccountData,
}